import { shape, string, number } from "prop-types"

export const TimesheetShape = shape({
    timesheetId: string.isRequired,
    status: number.isRequired,
    weekEnding: Date.isRequired
})